import ObjektService from '../../services/ObjektService'

const state = {
  items: {}
}

const getters = {
  items: state => state.items,
  thumb: state => objektId => state.items.hasOwnProperty(objektId) && state.items[objektId].photos.thumb ? state.items[objektId].photos.thumb || {} : {},
  large: state => objektId => state.items.hasOwnProperty(objektId) && state.items[objektId].photos.large ? state.items[objektId].photos.large || {} : {}
}

const actions = {
  load: ({commit, dispatch}, objektId) => {
    return new Promise((resolve, reject) => {
      let isLoading = state.items.hasOwnProperty(objektId) && state.items[objektId].loading
      let isSuccess = state.items.hasOwnProperty(objektId) && state.items[objektId].photos.thumb

      if (isLoading) {
        commit('skip')
        resolve()
      } else if (isSuccess) {
        let payload = {photos: state.items[objektId].photos, objektId: objektId}
        commit('success', payload)
        resolve(payload)
      } else {
        commit('load', objektId)

        ObjektService.getObjektPhotos(objektId)
          .then((response) => {
            let payload = {photos: response.data, objektId: objektId}
            commit('success', payload)
            resolve(payload)
          })
          .catch((error) => {
            commit('failure', objektId)
            reject(error)
          })
      }
    })
  }
}

const mutations = {
  load: (state, objektId) => {
    state.items[objektId] = {
      loading: true,
      photos: []
    }
  },
  skip: (state) => {
    // Don't do anything
  },
  success: (state, payload) => {
    if (state.items.hasOwnProperty(payload.objektId)) {
      state.items[payload.objektId].loading = false
      state.items[payload.objektId].photos = payload.photos
    }
  },
  failure: (state, objektId) => {
    if (state.items.hasOwnProperty(objektId)) {
      state.items[objektId].loading = false
      state.items[objektId].photos = []
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/objektimageloader.js